export enum PermissionEnum {
  ROLES = 'Roles',
  GROUPS = 'Groups',
  USERS = 'Users',
  USER_ROLES = 'UserRoles',
  CORRECTIVE_ACTIONS = 'CorrectiveActions',
  CALENDAR = 'Calendar',
  NOTIFICATIONS = 'Notifications',
  WORKFLOWS = 'Workflows',
  WORKER_MONITORING = 'WorkerMonitoring',
  SUMMARY_DASHBOARD = 'SummaryDashboard',
  LOGIN_DASHBOARD = 'LoginDashboard',
  USER_MONITORING = 'UserMonitoring',
  TICKET_WALLET = 'TicketWallet',
  DOCUMENTS = 'Documents',
  COMPANY = 'Company',
  DYNAMIC_REPORTS = 'DynamicReports',
}

export enum RolesEnum {
  ADMIN = 'Admin',
  SUPER_ADMIN = 'Super Admin',
}

export interface Role {
  id?: string;
  name: string;
  permissions?: {
    data: Permission[];
  };
}

export type RoleID = NonNullable<Role['id']>;

export interface Permission {
  name: string;
}
